import type {
  BonusQuestion,
  Club,
  HistoryEntry,
  LeagueParticipant,
  ManualAdjustment,
} from "@/modules/leagues/types/admin";

function hoursAgo(h: number): string {
  return new Date(Date.now() - h * 60 * 60 * 1000).toISOString();
}

export const MOCK_CLUBS_BY_COMPETITION: Record<string, Club[]> = {
  "brasileirao": [
    { id: "flamengo", name: "Flamengo", shortName: "FLA", crestUrl: null },
    { id: "palmeiras", name: "Palmeiras", shortName: "PAL", crestUrl: null },
    { id: "corinthians", name: "Corinthians", shortName: "COR", crestUrl: null },
    { id: "sao-paulo", name: "São Paulo", shortName: "SPFC", crestUrl: null },
    { id: "gremio", name: "Grêmio", shortName: "GRE", crestUrl: null },
    { id: "internacional", name: "Internacional", shortName: "INT", crestUrl: null },
    { id: "atletico-mg", name: "Atlético-MG", shortName: "CAM", crestUrl: null },
    { id: "botafogo", name: "Botafogo", shortName: "BOT", crestUrl: null },
    { id: "fluminense", name: "Fluminense", shortName: "FLU", crestUrl: null },
    { id: "vasco", name: "Vasco da Gama", shortName: "VAS", crestUrl: null },
  ],
  "libertadores": [
    { id: "flamengo", name: "Flamengo", shortName: "FLA", crestUrl: null },
    { id: "palmeiras", name: "Palmeiras", shortName: "PAL", crestUrl: null },
    { id: "river-plate", name: "River Plate", shortName: "RIV", crestUrl: null },
    { id: "boca-juniors", name: "Boca Juniors", shortName: "BOC", crestUrl: null },
    { id: "penarol", name: "Peñarol", shortName: "PEN", crestUrl: null },
  ],
};

// Estado mutável em memória — simula persistência dentro da sessão do navegador
// (equivalente ao que seria gravado no Firestore quando a implementação real entrar).
export const disabledClubsByLeague = new Map<string, string[]>();

export const participantsByLeague = new Map<string, LeagueParticipant[]>([
  [
    "liga-amigos-brasileirao",
    [
      { uid: "me", nome: "Rodrigo (você)", avatarUrl: null, role: "admin", pontos: 645, entrouEm: hoursAgo(24 * 40), status: "ativo" },
      { uid: "mock-0", nome: "Camila Souza", avatarUrl: null, role: "moderator", pontos: 590, entrouEm: hoursAgo(24 * 38), status: "ativo" },
      { uid: "mock-1", nome: "Bruno Lima", avatarUrl: null, role: "member", pontos: 512, entrouEm: hoursAgo(24 * 35), status: "ativo" },
      { uid: "mock-2", nome: "Ana Paula", avatarUrl: null, role: "member", pontos: 470, entrouEm: hoursAgo(24 * 30), status: "ativo" },
      { uid: "mock-3", nome: "Diego Ferreira", avatarUrl: null, role: "member", pontos: 410, entrouEm: hoursAgo(24 * 4), status: "pendente" },
    ],
  ],
  [
    "liga-trabalho-libertadores",
    [
      { uid: "me", nome: "Rodrigo (você)", avatarUrl: null, role: "member", pontos: 210, entrouEm: hoursAgo(24 * 15), status: "ativo" },
      { uid: "mock-4", nome: "Juliana Costa", avatarUrl: null, role: "admin", pontos: 340, entrouEm: hoursAgo(24 * 20), status: "ativo" },
    ],
  ],
]);

export const historyByLeague = new Map<string, HistoryEntry[]>([
  [
    "liga-amigos-brasileirao",
    [
      { id: "h1", type: "rule_frozen", descricao: "Regras de pontuação congeladas na criação da liga.", administrador: "Rodrigo", createdAt: hoursAgo(24 * 40) },
      { id: "h2", type: "bonus", descricao: "+15 pontos de bônus para Bruno Lima.", administrador: "Rodrigo", createdAt: hoursAgo(48) },
    ],
  ],
  ["liga-trabalho-libertadores", [{ id: "h3", type: "rule_frozen", descricao: "Regras de pontuação congeladas na criação da liga.", administrador: "Juliana Costa", createdAt: hoursAgo(24 * 15) }]],
]);

export const manualAdjustmentsByLeague = new Map<string, ManualAdjustment[]>([
  [
    "liga-amigos-brasileirao",
    [
      {
        id: "m1",
        participantUid: "mock-1",
        participantNome: "Bruno Lima",
        pontos: 15,
        motivo: "Acertou a pergunta bônus da rodada 14.",
        administrador: "Rodrigo",
        createdAt: hoursAgo(48),
      },
    ],
  ],
  ["liga-trabalho-libertadores", []],
]);

export const bonusQuestionsByLeague = new Map<string, BonusQuestion[]>([
  [
    "liga-amigos-brasileirao",
    [
      {
        id: "b1",
        pergunta: "Quem será o artilheiro da Rodada 15?",
        opcoes: ["Jogador A", "Jogador B", "Jogador C"],
        pontos: 20,
        rodada: 15,
        encerrada: false,
        respostaCorreta: null,
      },
    ],
  ],
  ["liga-trabalho-libertadores", []],
]);
